<ds-modal
  #legalNoticeModal
  [ds-modal-trigger-for]="legalNoticeModal"
  [isModalOpen]="modalIsOpen()"
  [dimensionsConfig]="{ width: '585px', height: '824px' }"
  [isDismissable]="true"
  (isModalOpenChange)="modalIsOpen.set($event)"
  (modalDismiss)="modalDismissed()"
>
  <ds-box-header size="md">{{ 'header.legalNoticeModal.title' | translate }}</ds-box-header>
  <ds-box-content>
    <p class="text-regular bold-600 mb-4x">
      {{ 'header.legalNoticeModal.firstSection.title' | translate }}
    </p>
    <ol type="a" class="text-regular mb-8x">
      <li>{{ 'header.legalNoticeModal.firstSection.content.rulesAndRegulations' | translate }}</li>
      <li>
        {{ 'header.legalNoticeModal.firstSection.content.sGateTerms' | translate }}
        <a href="{{ 'header.legalNoticeModal.firstSection.content.sGateTermsLink' | translate }}">{{
          'header.legalNoticeModal.firstSection.content.sGateTermsLink' | translate
        }}</a>
      </li>
      <li>
        {{ 'header.legalNoticeModal.firstSection.content.sGateDataProtection' | translate
        }}<a href="{{ 'header.legalNoticeModal.firstSection.content.sGateDataProtectionLink' | translate }}">{{
          'header.legalNoticeModal.firstSection.content.sGateDataProtectionLink' | translate
        }}</a
        >{{ 'header.legalNoticeModal.firstSection.content.sGateDataProtectionPure' | translate }}
      </li>
    </ol>
    <p class="text-regular bold-600 mb-4x">
      {{ 'header.legalNoticeModal.secondSection.title' | translate }}
    </p>
    <p class="text-regular mb-8x">{{ 'header.legalNoticeModal.secondSection.content' | translate }}</p>
    <p class="text-regular bold-600 mb-4x">
      {{ 'header.legalNoticeModal.thirdSection.title' | translate }}
    </p>
    <p class="text-regular mb-8x">{{ 'header.legalNoticeModal.thirdSection.content' | translate }}</p>
    <p class="text-regular bold-600 mb-4x">
      {{ 'header.legalNoticeModal.fourthSection.title' | translate }}
    </p>
    <p class="text-regular mb-8x">{{ 'header.legalNoticeModal.fourthSection.content' | translate }}</p>
    <p class="text-regular bold-600 mb-4x">
      {{ 'header.legalNoticeModal.fifthSection.title' | translate }}
    </p>
    <p class="text-regular mb-8x">{{ 'header.legalNoticeModal.fifthSection.content' | translate }}</p>
    <p class="text-regular bold-600 mb-4x">
      {{ 'header.legalNoticeModal.sixthSection.title' | translate }}
    </p>
    <p class="text-regular">{{ 'header.legalNoticeModal.sixthSection.content.bmw' | translate }}</p>
    <p class="text-regular">{{ 'header.legalNoticeModal.sixthSection.content.ca' | translate }}</p>
    <p class="text-regular">{{ 'header.legalNoticeModal.sixthSection.content.munich' | translate }}</p>
    <p class="text-regular">{{ 'header.legalNoticeModal.sixthSection.content.date' | translate }}</p>
  </ds-box-content>
  <ds-box-footer>
    <button id="btn-close-modal" ds-button #dsModalDismissElement>
      {{ 'common.buttons.close' | translate }}
    </button>
  </ds-box-footer>
</ds-modal>
